// src/components/authentication/ProtectedRoute.js
/**
 * Route guard that blocks unauthenticated users.
 *
 * Usage
 * -----
 * ```jsx
 * <Route
 *   path="/dashboard"
 *   element={
 *     <ProtectedRoute>
 *       <Dashboard />
 *     </ProtectedRoute>
 *   }
 * />
 * ```
 *
 * Behaviour
 * ----------
 * • Reads the current user from our `AuthContext` hook.
 * • If a user object exists → render the `children` prop (protected page).
 * • Otherwise → `<Navigate replace to="/auth" />` to show the login flow.
 *
 * Props
 * @param {{ children: React.ReactElement }} props
 *   React element(s) to render once the user is authenticated.
 *
 * @returns {JSX.Element}
 */

import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/auth" replace />;
}
